export default {
  data() {
    return {
      headers: [
        {
          label: "Estratégia",
          key: "strategy_name",
        },
        {
          label: "Ativo",
          key: "position_symbol",
        },
        {
          label: "Posição",
          key: "position_status",
        },
        {
          label: "Horário",
          key: "position_time",
        },
        {
          label: "Preço",
          key: "position_price",
        },
        {
          label: "SL",
          key: "position_sl",
          tooltip: "Stop loss",
        },
        {
          label: "TP",
          key: "position_tp",
          tooltip: "Take profit",
        },
        {
          label: "Resultado",
          key: "open_pnl",
        },
        {
          label: "Comentário",
          key: "position_comment",
        },
      ],
      mock_data: [
        {
          type: "STRATEGY",
          investment_id: Math.floor(Math.random() * 10000),
          strategy_name: "Dusma 80",
          strategy_symbol: "WINFUT",
          position_status: "BUY",
          position_volume: 2,
          start_datetime: "19/12/2023 - 10:54:12",
          price: 123123,
          sl: 123000,
          tp: 124000,
          open_pnl: 123.12,
          comment: "Comprado",
        },
        {
          type: "STRATEGY",
          investment_id: Math.floor(Math.random() * 10000),
          strategy_name: "Dusma 80",
          strategy_symbol: "WINFUT",
          position_status: "SELL",
          position_volume: 1,
          start_datetime: "19/12/2023 - 10:54:12",
          price: 123123,
          sl: 123000,
          tp: 124000,
          open_pnl: 123.12,
          comment: "Vendido",
        },
        {
          type: "PORTFOLIO",
          investment_id: 10000,
          strategy_name: "Portfólio AA",
          curr_positions: [
            {
              type: "STRATEGY",
              investment_id: 10001,
              strategy_symbol: "WDOFUT",
              position_status: "SELL",
              position_volume: 1,
              start_datetime: "19/12/2023 - 10:54:12",
              price: 123123,
              sl: 123000,
              tp: 124000,
              open_pnl: 123,
              comment: "Vendido",
            },
            {
              type: "STRATEGY",
              investment_id: 10002,
              strategy_symbol: "WINFUT",
              position_status: "BUY",
              position_volume: 1,
              start_datetime: "19/12/2023 - 10:54:12",
              price: 123123,
              sl: 123000,
              tp: 124000,
              open_pnl: -98,
              comment: "Comprado",
            },
            {
              type: "STRATEGY",
              investment_id: 10003,
              strategy_symbol: "CCMFUT",
              position_status: "BUY",
              position_volume: 1,
              start_datetime: "19/12/2023 - 10:54:12",
              price: 123123,
              sl: 123000,
              tp: 124000,
              open_pnl: 200,
              comment: "Comprado",
            },
          ],
        },
        {
          type: "PORTFOLIO",
          investment_id: 10004,
          strategy_name: "Portfólio AA",
          curr_positions: [
            {
              type: "STRATEGY",
              investment_id: 10005,
              strategy_symbol: "WDOFUT",
              position_status: "SELL",
              position_volume: 1,
              start_datetime: "19/12/2023 - 10:54:12",
              price: 123123,
              sl: 123000,
              tp: 124000,
              open_pnl: 123,
              comment: "Vendido",
            },
            {
              type: "STRATEGY",
              investment_id: 10006,
              strategy_symbol: "WINFUT",
              position_status: "BUY",
              position_volume: 1,
              start_datetime: "19/12/2023 - 10:54:12",
              price: 123123,
              sl: 123000,
              tp: 124000,
              open_pnl: -98,
              comment: "Comprado",
            },
            {
              type: "STRATEGY",
              investment_id: 10007,
              strategy_symbol: "CCMFUT",
              position_status: "BUY",
              position_volume: 1,
              start_datetime: "19/12/2023 - 10:54:12",
              price: 123123,
              sl: 123000,
              tp: 124000,
              open_pnl: 200,
              comment: "Comprado",
            },
          ],
        },
      ],
    };
  },
};
